import React from 'react';
import Button from "../../../Components/Auth/Button";
import { useNavigate } from "react-router";

const InitialEntryDialog = ({ formik, handleContinue, handleFieldChange }) => {
    const navigate = useNavigate();

    return (
        <div className="bg-white rounded-[12px] shadow-xl p-6 lg:p-8 w-full max-w-lg mx-auto relative">
            <div className="bg-gradient-to-r h-[6px] rounded-t-[12px] from-[#00C05B] to-[#007FFF] w-full absolute top-0 left-0 right-0"></div>
            <h2 className="text-xl font-archivo font-bold text-[#0081F8] lg:text-[24px] mt-2">Create your account</h2>
            <p className="text-black/60 mb-6 text-sm">Step 1: Enter your name and email.</p>

            <form noValidate>
                <div className="grid grid-cols-2 gap-4 mb-2">
                    <div>
                        <input type="text" name="firstName" placeholder="First Name*" value={formik.values.firstName} onChange={handleFieldChange} onBlur={formik.handleBlur}
                            className={`px-4 py-2 border w-full rounded-full focus:outline-none ${formik.touched.firstName && formik.errors.firstName ? "border-red-500" : "border-[#00000033]"}`} />
                        <div className="text-red-500 text-[10px] mt-1">{formik.touched.firstName && formik.errors.firstName}</div>
                    </div>
                    <div>
                        <input type="text" name="lastName" placeholder="Last Name*" value={formik.values.lastName} onChange={handleFieldChange} onBlur={formik.handleBlur}
                            className={`px-4 py-2 border w-full rounded-full focus:outline-none ${formik.touched.lastName && formik.errors.lastName ? "border-red-500" : "border-[#00000033]"}`} />
                        <div className="text-red-500 text-[10px] mt-1">{formik.touched.lastName && formik.errors.lastName}</div>
                    </div>
                </div>
                <div className="mb-4">
                    <input type="email" name="email" placeholder="Email Address*" value={formik.values.email} onChange={handleFieldChange} onBlur={formik.handleBlur}
                        className={`px-4 py-2 border w-full rounded-full focus:outline-none ${formik.touched.email && formik.errors.email ? "border-red-500" : "border-[#00000033]"}`} />
                    <div className="text-red-500 text-[10px] mt-1">{formik.touched.email && formik.errors.email}</div>
                </div>
                <Button type="button" text="Continue" onClick={handleContinue} />
            </form>
            <p className="text-center text-sm mt-4 text-gray-500">Already have an account? <span className="text-green-600 font-bold cursor-pointer" onClick={() => navigate("/login")}>Login</span></p>
        </div>
    );
};

export default InitialEntryDialog;